import {CanActivateFn, Router} from '@angular/router';
import {inject} from '@angular/core';
import {ReservationService} from '../api/reservation.service';
import {CheckInFlowService} from '../services/check-in-flow.service';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {hasMissingChildCheckIns} from '../../shared/models/check-in-flow.model';


export const reservationHasMinorPendingCheckInsGuard: CanActivateFn = () => {
  const reservationService = inject(ReservationService);
  const checkInFlowService = inject(CheckInFlowService);
  const router = inject(Router);

  return reservationService.getReservation().pipe(
    mergeMap((reservation) => {
      return checkInFlowService.get(reservation).pipe(
        map((checkInFlowData) => {
          if (checkInFlowData.checkinCompleted) {
            return router.parseUrl('/');
          }
          if (!hasMissingChildCheckIns(checkInFlowData)) {
            return router.parseUrl('/');
          }
          return true;
        })
      );
    }),
    catchError(() => of(router.parseUrl('/')))
  );
};

